<!-- Toggle -->
<div>
  <label class="form-label">
    <ng-container *ngTemplateOutlet="label; context: { toggled: checked }"></ng-container>
  </label>

  <fieldset [attr.disabled]="disabled === true || null">
    <div class="form-check form-check-inline">
      <input
        class="form-check-input"
        [id]="formControlName + '_true'"
        [name]="formControlName + '_true'"
        [ngModel]="checked"
        [value]="true"
        (ngModelChange)="update($event)"
        type="radio"
      />

      <label class="form-check-label" [for]="formControlName + '_true'">
        {{ 'switch.yes' | portalTranslate }}
      </label>
    </div>

    <div class="form-check form-check-inline">
      <input
        class="form-check-input"
        [id]="formControlName + '_false'"
        [name]="formControlName + '_false'"
        [ngModel]="checked"
        [value]="false"
        (ngModelChange)="update($event)"
        type="radio"
      />

      <label class="form-check-label" [for]="formControlName + '_false'">
        {{ 'switch.no' | portalTranslate }}
      </label>
    </div>
  </fieldset>

  <!--  <input-->
  <!--    #toggle-->
  <!--    (change)="update(toggle.checked)"-->
  <!--    [checked]="checked"-->
  <!--    [id]="formControlName"-->
  <!--    class="form-check-input"-->
  <!--    type="checkbox"-->
  <!--  />-->
</div>

<!-- Value -->
@if (checked === true) {
  <div class="form-group">
    <ng-container *ngTemplateOutlet="input"></ng-container>
    <portal-form-validation-errors [controlName]="formControlName"></portal-form-validation-errors>
  </div>
}
